enum ReportTypesEnum {
  ANALYTICAL = 'analytical',
  SYNTHETIC = 'synthetic',
}

export default ReportTypesEnum;
